import isValidSessionLength from "./isValidSessionLength";

/**
 * Check if the session has valid length
 * @param value session length value
 */
export default function isValidSessionType(
  value: Partial<SessionType> | undefined,
) {
  if (!value) {
    return false;
  }

  if (!value.label || !value.length_min) {
    return false;
  }

  // undefined or null
  if (!value.price && value.price !== 0) {
    return false;
  }

  if (Number(value.price) < 0) {
    return false;
  }

  if (!isValidSessionLength(value.length_min)) {
    return false;
  }

  return true;
}
